import type { ReactElement, ReactNode } from 'react';
import styled from 'styled-components';

export interface ImageWrapperProps {
  children: ReactNode;
  fill: boolean;
}

const Wrap = styled.div`
  padding: 8px 0;

  img {
    width: 100% !important;
    height: unset !important;
    position: relative !important;
  }
`;

export const ImageWrapper = ({
  children,
  fill,
}: ImageWrapperProps): ReactElement => {
  if (!fill) return <>{children}</>;

  return <Wrap>{children}</Wrap>;
};
